import { DataModel } from '../dto/data-model.js';
import { PaymentAccountRef } from './payment-account-ref.js';
import { PaymentType } from './payment-type.js';

export abstract class PaymentProtocolBase extends DataModel {
  abstract get paymentAccount(): PaymentAccountRef;
  abstract get paymentMethods(): PaymentType[];
  abstract get allowLegalEntityInvoices(): boolean;
  abstract get allowOfflineOrderReceipts(): boolean;
}
